export enum ESplashTypes {
  CYBERFARM = "cyberfarm",
}
